import { render, staticRenderFns } from "./BuilderRibbonTooltip.vue?vue&type=template&id=26117dd6&scoped=true&"
import script from "./BuilderRibbonTooltip.vue?vue&type=script&lang=js&"
export * from "./BuilderRibbonTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BuilderRibbonTooltip.vue?vue&type=style&index=0&id=26117dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26117dd6",
  null
  
)

export default component.exports